<template>
    <div >
        <base-loading :visible="isLoading" />
        <pdf-viewer :isOpen="showPdf" :pdfUrl="pdfUrl" @close="showPdf = false" />
        <add-transaction :isOpen="isOpen" @close="isOpen = false" :clientList="clientList" :weekList="weekList"
            :item="item" :isEditing="isEditing" @refresh="doSearch" />
        <!-- Search Bar -->
        <vs-row class="mb-4">
            <vs-col vs-lg="1" vs-sm="6" vs-xs="12" class="p-1">
                <export-button class="w-full" :client="filters.client" />
            </vs-col>
            <!-- <vs-col vs-lg="2" vs-sm="6" vs-xs="12" class="p-1">
                <vs-button @click="addTrasaction" class="w-full" icon-pack="feather" icon="icon-upload">{{
                    $t('add_transaction') }}</vs-button>
            </vs-col> -->
            <vs-col vs-lg="8" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="center">
                <balance-indicator :balance="balance" currency="MXN" v-if="filters.client != null" />
            </vs-col>
            <vs-col vs-lg="2" vs-sm="8" vs-xs="12" class="p-1">
                <search-input v-model="search" @handleSearch="doSearch" class="w-full" />
            </vs-col>
            <vs-col vs-lg="1" vs-sm="4" vs-xs="12" class="p-1">
                <bonus-filter :clientList="clientList" :filters="filters" @apply-filters="applyFilters" />
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col>
                <bonus-table :items="items" @loadMore="loadMore()" @edit="editTransaction" @openFile="openPdfViewer"
                    @downloadFile="downloadFile" />
            </vs-col>
        </vs-row>
       

    </div>
</template>

<script>
import { formatCurrency } from '@/utils/helpers'
import ExportButton from './components/ExportButton.vue';
import BalanceIndicator from './components/BalanceIndicator.vue';
import BonusTable from './components/BonusTable.vue';
import SearchInput from '@/views/app/components/inputs/SearchInput.vue';
import BonusFilter from './components/BonusFilter.vue';
import request from './request';
import AddTransaction from './components/AddTransaction.vue';
import PdfViewer from '@/views/app/components/modals/PdfViewer.vue';
import { BASE_URL } from '@/urls.js'
import axios from '@/http/axios/index.js'
import BaseLoading from '@/views/app/components/loading/BaseLoading.vue';
export default {
    components: { BalanceIndicator, ExportButton, BonusTable, AddTransaction, SearchInput, BonusFilter, PdfViewer,BaseLoading },
    data() {
        return {
            showPdf: false,
            pdfUrl: '',
            isOpen: false,
            items: [],
            item: {
                client_id: null,
                prov_aguinaldo: '',
                week: null
            },
            isEditing: false,
            weekList: [],
            clientList: [],
            search: '',
            page: 1,
            lastPage: 1,
            balance: null,
            filters: {
                client: null
            },
            loading: {
                list: false,
                client: false,
                week: false
            }
        }
    },
    computed: {
        isLoading() {
            return this.loading.list || this.loading.client || this.loading.week
        }
    },
    methods: {
        formatCurrency,
        openPDF() {
            this.showPdf = true
            console.log('show pdf')
        },
        loadMore() {
            if (this.page >= this.lastPage) {
                return
            }
            this.page++
            this.getList()
        },
        addTrasaction() {
            this.isOpen = true
            this.editing = false
        },
        editTransaction(item) {
            this.isOpen = true
            this.isEditing = true
            this.item = {
                client_id: item.client_id,
                prov_aguinaldo: item.amount == null ? item.prov_aguinaldo : item.amount,
                week: item.week,
            }
        },
        getList() {
            const payload = {
                search: this.search.trim(),
                page: this.page,
                client_id: this.filters.client
            }
            this.loading.list = true

            request.getList(payload)
                .then(response => {
                    if (this.page === 1) {
                        this.items = [...response.data.list.data]
                    } else {
                        this.items = [...this.items, ...response.data.list.data]
                    }
                    this.balance = response.data.balance
                    this.lastPage = response.data.list.last_page
                    this.page = response.data.list.current_page
                    this.loading.list = false
                })
                .catch(response => {
                    this.loading.list = false
                    console.log(response)
                })
        },
        getClients() {
            this.loading.client = true
            request.getClients()
                .then(response => {
                    this.clientList = [...response.data]
                    this.loading.client = false
                })
                .catch(response => {
                    this.loading.client = false
                    console.log(response)
                })
        },
        getWeeks() {
            this.loading.week = true
            request.getWeeks()
                .then(response => {
                    this.loading.week = false
                    this.weekList = [...response.data]
                })
                .catch(response => {
                    this.loading.week = false
                    console.log(response)
                })
        },
        applyFilters(filters){
            this.filters = { ...filters }
            this.doSearch()
        },
        doSearch() {
            this.page = 1
            this.getList()
        },
        openPdfViewer(item) {
            this.pdfUrl = `${BASE_URL}internal_api/bonus_reserve/${item.client_id}-${item.week}-fa4db_49cb_4571_8664_946a46e736e2`
            //this.pdfUrl = 'http://10.147.20.150:1213/internal_api/bonus_reserve/8-2025-15-fa4db_49cb_4571_8664_946a46e736e2'
            this.showPdf = true
        },
        async downloadFile(item) {
            const url =  `${BASE_URL}internal_api/bonus_reserve/${item.client_id}-${item.week}-fa4db_49cb_4571_8664_946a46e736e2`
            //const url = 'http://10.147.20.150:1213/internal_api/bonus_reserve/8-2025-15-fa4db_49cb_4571_8664_946a46e736e2'
            const response = await axios.get(url, { responseType: 'blob' })
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'archivo.pdf' // nombre del archivo
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }



    },
    mounted() {
        this.getList()
        this.getClients()
        this.getWeeks()
    }
}

</script>

<style></style>
